import background from 'assets/backgrounds/onboarding-background.png';
import GradientView from 'components/UI/Banner/GradientView';
import AbsoluteBox from 'components/UI/Layout/AbsoluteBox';
import FlexBox from 'components/UI/Layout/FlexBox';
import Svg from 'components/UI/Svg/Svg';
import { Spacing } from 'modules/styles/variables';
import React from 'react';
import styled from 'styled-components';

export const LandingImageBackground = styled(FlexBox)`
  height: 100%;
  width: 100%;
  background: url(${background});
  background-size: cover;
`;

interface StethoscopeBackgroundProps {
  children?: React.ReactNode;
}
const StethoscopeBackground = ({ children }: StethoscopeBackgroundProps) => {
  return (
    <GradientView>
      <LandingImageBackground>
        <AbsoluteBox right={Spacing.large} top={Spacing.xxLarge}>
          <Svg name="Stethoscope" size="250" set="assets" />
        </AbsoluteBox>

        {children}
      </LandingImageBackground>
    </GradientView>
  );
};

export default StethoscopeBackground;
